import { faShip, faUmbrellaBeach, faUsers, faPlaneUp, faEarthEurope, faHeart, faCalendar, faRing } from "@fortawesome/free-solid-svg-icons";
import { faFortAwesome } from "@fortawesome/free-brands-svg-icons";

export default [
  {
    title: "Family Vacation Planning",
    icon: faUsers,
  },
  {
    title: "Cruises",
    icon: faShip,
  },
  {
    title: "All-Inclusive Resorts",
    icon: faUmbrellaBeach,
  },
  {
    title: "Disney Vacations",
    icon: faFortAwesome,
  },
  {
    title: "European Vacations",
    icon: faEarthEurope,
  },
  {
    title: "Destination Weddings",
    icon: faRing,
  },
  {
    title: "Honeymoons",
    icon: faHeart,
  },
  {
    title: "Custom Itineraries",
    icon: faCalendar,
  },
  {
    title: "And Many More!",
    icon: faPlaneUp,
  },
];
